import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import styled from 'styled-components';

export const ButtonLoaderWrapper = styled(ButtonLoader)`
  width: 200px;
  max-width: 200px;
  margin: 30px auto 0;
`;

const Wrapper = styled.div``;

export default Wrapper;
